import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { registryApi } from "@/api";
import { useLang } from "@/i18n";

export const RegistrySettings = () => {
  const { t } = useLang();
  const [s, setS] = useState(null);
  const [pwd, setPwd] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { registryApi.settings().then(setS); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      setS(await registryApi.saveSettings({ mode: s.mode, username: s.username, afm_called_by: s.afm_called_by, password: pwd.trim() ? pwd.trim() : null }));
      setPwd(""); toast.success(t("settings_saved"));
    } catch { toast.error(t("error")); } finally { setSaving(false); }
  };

  if (!s) return null;
  return (
    <form onSubmit={submit} className="erp-card p-6 max-w-3xl space-y-5 page-enter" data-testid="registry-settings-card">
      <div className="flex items-center gap-2"><Search size={18} className="text-blue-700" /><h2 className="text-xl font-heading font-bold tracking-tight">{t("aade_registry_title")}</h2></div>
      <p className="text-sm text-slate-500">{t("aade_registry_hint")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-slate-500">{t("mydata_mode")}</Label>
          <Select value={s.mode} onValueChange={(v) => setS({ ...s, mode: v })}>
            <SelectTrigger data-testid="registry-mode-select"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="mock">{t("mode_mock")}</SelectItem><SelectItem value="live">{t("mode_live")}</SelectItem></SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-slate-500">{t("aade_called_by")}</Label>
          <Input value={s.afm_called_by} onChange={(e) => setS({ ...s, afm_called_by: e.target.value })} className="font-mono" data-testid="registry-called-by-input" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-slate-500">{t("aade_username")}</Label>
          <Input value={s.username} onChange={(e) => setS({ ...s, username: e.target.value })} className="font-mono" data-testid="registry-username-input" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-slate-500">{t("aade_password")} {s.has_password && <span className="text-emerald-600 normal-case">(••••)</span>}</Label>
          <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder={s.has_password ? t("mydata_key_hint") : ""} className="font-mono" autoComplete="new-password" data-testid="registry-password-input" />
        </div>
      </div>
      <div className="flex justify-end"><Button type="submit" disabled={saving} className="bg-blue-800 hover:bg-blue-700" data-testid="registry-settings-submit-button">{t("save")}</Button></div>
    </form>
  );
};
